"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiBadge = void 0;
exports.MuiBadge = {
    styleOverrides: {
        root: {
            alignItems: 'center',
        },
        badge: {
            borderRadius: 4,
            height: 18,
            fontSize: 12,
            position: 'relative',
            marginLeft: 8,
        },
        anchorOriginTopRightRectangular: {
            transform: 'initial',
        },
        anchorOriginBottomRightRectangular: {
            transform: 'initial',
        },
        anchorOriginBottomLeftRectangular: {
            transform: 'initial',
        },
        anchorOriginTopLeftRectangular: {
            transform: 'initial',
        },
        anchorOriginBottomRightCircular: {
            transform: 'initial',
        },
        anchorOriginTopLeftCircular: {
            transform: 'initial',
        },
        anchorOriginTopRightCircular: {
            transform: 'initial',
        },
    },
};
//# sourceMappingURL=MuiBadge.js.map